import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { IntegracaoService } from 'src/app/services/integracao.service'
import { Integracao } from 'src/app/models/integracao.model'
import { PlataformaService } from 'src/app/services/plataforma.service';

@Component({
  selector: 'app-integracao',
  templateUrl: './integracao.component.html',
  styleUrls: ['./integracao.component.css']
})
export class IntegracaoComponent implements OnInit {
  formParamIntegracao: FormGroup;
  idEleicao: any;
  integracaoDados: Integracao = new Integracao();
  tokenAuth: any;
  editando: boolean = false;
  idIntegracao: any;
  btOff: boolean = false;
  eleicaoParametrizando: any;
  listaPlataformas: any;
  textSrc: string;
  chavePublicaTexto: string | undefined;
  chavePrivadaTexto: string | undefined;

  constructor(
    public integracaoService: IntegracaoService,
    protected messageService: MessageService,
    protected plataformas: PlataformaService
  ) { }

  async ngOnInit() {
    this.eleicaoParametrizando = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    this.idEleicao = this.eleicaoParametrizando.id;
    this.tokenAuth = sessionStorage.getItem("token");
    this.formParamIntegracao = new FormGroup({
      login: new FormControl(),
      senha: new FormControl(),
      url: new FormControl(),
      alterarSenhaUrl: new FormControl(),
      logoutUrl: new FormControl(),
      plataformaId: new FormControl(),
      textoForaDoPeriodoEleitoral: new FormControl(),
      textoSemAcessoVotacao: new FormControl(),
      textoSemAcessoCandidatura: new FormControl(),
      textoSessaoExpirada: new FormControl(),
      //publicKey: new FormControl(),
      //privateKey: new FormControl()
    })
    if(this.eleicaoParametrizando.acessoIntegracao == true || this.eleicaoParametrizando.acessoIntegracao == "true"){
      this.listarDadosExistentes();
      this.buscarPlataformas();
    } else {
      this.formParamIntegracao.disable();
      this.btOff = true;
    }
   
  }
  listarDadosExistentes(){
    this.integracaoService.listarPorIdEleicao(this.idEleicao, this.tokenAuth).then((data: any) => {
      this.formParamIntegracao.patchValue(data);
      this.editando = true;
      this.idIntegracao = data.id;
      this.chavePublicaTexto = data.publicKey;
      this.chavePrivadaTexto = data.privateKey;
     
    }, err => {
      console.log(err); //TODO
    })
  }
  ValidURL(str) {
    var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    if(!regex .test(str)) {
      return false;
    } else {
      return true;
    }
  }
  validateUrlOnBlur(event){
    if(this.ValidURL(event.target.value)){
      return true;
    }else {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: "Insira uma url válida." });
      event.target.focus();
    }
  }

  async buscarPlataformas(){
    await this.plataformas.listar(this.tokenAuth).then((data: any) => {
      this.listaPlataformas = data;
    });
  }
     
  

  handleInputChange(e,campo) {
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var pattern = /text-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.readAsText(file);
    reader.onload = this._handleReaderLoaded.bind(this,campo);
    
  }
  _handleReaderLoaded(campo, e) {
    let reader = e.target;
    if(campo =='publicKey'){
     this.chavePublicaTexto = reader.result as string;
    }else if(campo=='privateKey'){
      this.chavePrivadaTexto = reader.result as string;
    }
  }
  
  


  submit() {
    //if(this.ValidURL(this.formParamIntegracao.get("url").value) && this.ValidURL(this.formParamIntegracao.get("alterarSenhaUrl").value)){
    if(true){ 
    this.btOff = true;
      document.body.style.cursor = 'wait';
      this.integracaoDados.login = this.formParamIntegracao.get('login').value;
      this.integracaoDados.senha = this.formParamIntegracao.get('senha').value;
      this.integracaoDados.url = this.formParamIntegracao.get('url').value;
      this.integracaoDados.plataformaId = +this.formParamIntegracao.get('plataformaId').value;
      this.integracaoDados.alterarSenhaUrl = this.formParamIntegracao.get('alterarSenhaUrl').value;
      this.integracaoDados.logoutUrl = this.formParamIntegracao.get('logoutUrl').value;
      this.integracaoDados.publicKey = this.chavePublicaTexto;
      this.integracaoDados.privateKey = this.chavePrivadaTexto;
      this.integracaoDados.eleicao = {"id": this.idEleicao};
      this.integracaoDados.textoForaDoPeriodoEleitoral = this.formParamIntegracao.get('textoForaDoPeriodoEleitoral').value;
      this.integracaoDados.textoSemAcessoCandidatura = this.formParamIntegracao.get('textoSemAcessoCandidatura').value;
      this.integracaoDados.textoSemAcessoVotacao = this.formParamIntegracao.get('textoSemAcessoVotacao').value;
      this.integracaoDados.textoSessaoExpirada = this.formParamIntegracao.get('textoSessaoExpirada').value;
      if(this.editando == false){
        this.integracaoService.salvarIntegracaoEleicao(this.integracaoDados, this.tokenAuth).then(data => {
          this.messageService.add({ key: 'toast', severity: 'success', summary: '', detail: "Dados da integração inseridos com sucesso" });
          this.btOff = false;
          document.body.style.cursor = 'default';
        }, err =>{
          this.messageService.add({ key: 'toast', severity: 'error', summary: err.error.error + ' ' + err.error.message, detail: "" });
          document.body.style.cursor = 'default';
          this.btOff = false;
          console.log(err);
        })
      }else{
        this.integracaoService.editarIntegracaoEleicao(this.idIntegracao, this.integracaoDados, this.tokenAuth).then(data => {
          document.body.style.cursor = 'default';
          this.btOff = false;
          this.messageService.add({ key: 'toast', severity: 'success', summary: '', detail: "Dados da integração atualizados" });
        }, err =>{
          this.messageService.add({ key: 'toast', severity: 'error', summary: err.error, detail: "" });
          console.log(err);
          document.body.style.cursor = 'default';
          this.btOff = false;
        })
      }
    }else {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: "Insira uma url válida." });
    }
  }
}
